/* eslint-disable no-loop-func */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
//import _ from "lodash";
import { xhrRequest } from "../internal/index.js";
import Loader from "core/loader/index";
//import loadFileRequest from "../WADO-URI/loadFileRequest";

function getLoaderForScheme(scheme) {
  // if (scheme === "dicomweb" || scheme === "wadouri") {
  //   return xhrRequest;
  // } else if (scheme === "dicomfile") {
  //   return loadFileRequest;
  // }
  if (scheme === "dicomweb" || scheme === "wadouri") {
    return xhrRequest;
  }
  // } else if (scheme === "dicomfile") {
  //   return loadFileRequest;
  // }
}
function parseImageId(imageId) {
  // build a url by parsing out the url scheme and frame index from the imageId
  const firstColonIndex = imageId.indexOf(":");
  let url = imageId.substring(firstColonIndex + 1);
  const frameIndex = url.indexOf("frame=");
  let frame;

  if (frameIndex !== -1) {
    const frameStr = url.substr(frameIndex + 6);

    frame = parseInt(frameStr, 10);
    url = url.substr(0, frameIndex - 1);
  }

  return {
    scheme: imageId.substr(0, firstColonIndex),
    url,
    frame,
  };
}

function initialize(config) {}

async function handler(data, doneCallback) {
  // handle initialize message
  switch (data.taskType) {
    case "initialize":
      initialize(data);
      break;
    case "fetchDICOM":
      const parsedURL = parseImageId(data.data);
      const loader = getLoaderForScheme(parsedURL.scheme);
      const loadDICOMPromise = loader(parsedURL.url, data.data);
      try {
        await loadDICOMPromise.then(function (
          dicomPart10AsArrayBuffer /* , xhr*/
        ) {
          let dicomLoader = new Loader.LoaderDicom();
          dicomLoader
            .parseFile(parsedURL.url, dicomPart10AsArrayBuffer)
            .then(function (parsedData) {
              postMessage({
                taskType: "parsedDICOM",
                workerIndex: data.workerIndex,
                data: parsedData,
                status: "success",
                result: {},
              });
            });
        });
      } catch (ex) {
        console.log("Exception : " + ex);
      }
      break;
    // eslint-disable-next-line no-fallthrough
    case "fetchDICOMChunk":
      // var t0 = performance.now();
      // let totalFiles = data.data.length;
      // let loadedFiles = 0;
      const chunckSize = 20;
      //console.log("data.data : " + data.data);
      data.data.__proto__ = Array.prototype;
      //console.log("type data.data : " + typeof data.data);
      const urls = data.data;
      const dataCount = urls.length;
      const cacheChunks = new Array(Math.ceil(urls.length / chunckSize))
        .fill()
        .map((_) => {
          return urls.splice(0, chunckSize);
        });

      //console.log("dataCount : " + dataCount);
      let loadedData = [];
      let loadedDataCount = 0;
      for (let chunk of cacheChunks) {
        await Promise.all(
          chunk.map(async function (url) {
            const parsedURL = parseImageId(url);
            const loader = getLoaderForScheme(parsedURL.scheme);
            const loadDICOMPromise = loader(parsedURL.url, url);

            try {
              let result = await loadDICOMPromise.then(function (
                dicomPart10AsArrayBuffer /* , xhr*/
              ) {
                let dicomLoader = new Loader.LoaderDicom();
                dicomLoader
                  .parseFile(parsedURL.url, dicomPart10AsArrayBuffer)
                  .then(function (parsedData) {
                    loadedData.push(parsedData);
                    loadedDataCount = loadedDataCount + 1;

                    if (loadedDataCount >= dataCount) {
                      //console.log("Complete");
                      //console.log("loadedDataCount : " + loadedDataCount);
                      //console.log("urls.length : " + dataCount);
                      postMessage({
                        taskType: "fetchDICOMChunk",
                        workerIndex: data.workerIndex,
                        data: loadedData,
                        status: "success",
                        result: {},
                      });
                    }
                  });
              });
            } catch (ex) {}
          })
        ).then(() => {
          //console.log("allpromise all");
        });
      }
      // for (let chunk of cacheChunks) {
      //   //console.log("wait");
      //   await Promise.all(
      //     // eslint-disable-next-line no-loop-func
      //     chunk.map(async function (url) {
      //       const parsedURL = parseImageId(url);
      //       const loader = getLoaderForScheme(parsedURL.scheme);
      //       const loadDICOMPromise = loader(parsedURL.url, url);

      //       try {
      //         await loadDICOMPromise.then(function (
      //           dicomPart10AsArrayBuffer /* , xhr*/
      //         ) {
      //           setTimeout(function () {
      //             try {
      //               let dicomLoader = new Loader.LoaderDicom();
      //               dicomLoader
      //                 .parseFile(parsedURL.url, dicomPart10AsArrayBuffer)
      //                 .then(function (parsedData) {
      //                   postMessage({
      //                     taskType: "parsedDICOM",
      //                     workerIndex: data.workerIndex,
      //                     data: parsedData,
      //                     status: "success",
      //                     result: {},
      //                   });
      //                   // let metadataCache = new Cache.Metadata();
      //                   // const seriesInstanceUID = data.seriesInstanceUID;
      //                   // const modality = data.modality;
      //                   // if (
      //                   //   !Helper.Validator.isString(seriesInstanceUID) ||
      //                   //   !Helper.Validator.isString(modality)
      //                   // ) {
      //                   //   console.error(
      //                   //     "DICOM Data Type is not correct : seriesInstanceUID or modality"
      //                   //   );
      //                   //   return;
      //                   // }

      //                   // metadataCache.add(seriesInstanceUID, modality, data);
      //                 })
      //                 .catch(function (err) {
      //                   console.error(err);
      //                 })
      //                 .finally(() => {
      //                   loadedFiles += 1;
      //                 });
      //             } catch (ex) {
      //               console.log("Exception load");
      //             }
      //           }, 0);
      //         });
      //       } catch (ex) {
      //         loadedFiles += 1;
      //       }
      //     })
      //   ).then(() => {
      //     var t2 = performance.now();
      //     console.log("Call to comp2 took " + (t2 - t0) / 1000 + " sec");
      //   });
      // }
      break;
    default:
      throw "error : not supported Webworker Task";
  }
}
export default {
  //taskType: "fetchDICOM",
  taskType: "fetchDICOMChunk",
  handler,
  initialize,
};
